<template>

    <div class="tool-container-compose-toolbar">

        <b-row class="mb-3">
            <b-col cols="7">
                <div class="mr-3"
                     v-if="tool.options.steps.length > 1">
                    <!-- step index -->
                    Step
                    <span class="label label-primary step-number">{{ step.id }}</span>
                    /
                    {{ steps.length }}

                    <!-- help button -->
                    <b-btn variant="default" class="help-link ml-3"
                           id="help-popover-target">
                        ?
                    </b-btn>
                    <!-- help popover -->
                    <b-popover target="help-popover-target">
                        <template v-slot:title>Help</template>
                        <div v-html="help"></div>
                    </b-popover>
                </div>

            </b-col>
            <b-col cols="5" class="text-right">
                <div v-if="tool.options.steps.length > 1">
                    <!-- previous button -->
                    <b-btn variant="primary" class="ml-2 btn-icon"
                           :disabled="docData.currentStep == 1"
                           @click="changeStep(-1)">
                        <open-icon name="arrow-left"></open-icon>
                        <span class="d-none d-sm-inline">
                            Previous Step
                        </span>
                    </b-btn>

                    <!-- next button-->
                    <b-btn variant="primary" class="ml-2 btn-icon"
                           :disabled="docData.currentStep == steps.length || !$store.state.currentStepIsValid"
                           @click="changeStep(1)">
                            <span class="d-none d-sm-inline">
                                Next Step
                            </span>
                        <open-icon name="arrow-right"></open-icon>
                    </b-btn>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="tool.options.steps.length > 1">
            <b-col>
                <!-- step title -->
                <h4 class="step-title">
                    {{ step.title }}
                </h4>
            </b-col>
        </b-row>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ToolContainerComposeToolbar",
        mixins: [ToolMixin],
        methods: {
            changeStep(jump) {
                this.doc.data.currentStep = this.doc.data.currentStep + jump
                this.save()
            },
        },
    })
</script>

<style lang="scss">

    .tool-container-compose-toolbar {

    }

</style>
